import FadingElementList from 'components/FadingElementList';
import React, { CSSProperties, FC } from 'react';
import { FormattedMessage } from 'react-intl';

const ICON_STYLE: CSSProperties = { position: 'relative', top: '1px' };

const AILoader: FC<{
  text?: string;
  footerElementShowAfterMillis?: number;
}> = ({ text, footerElementShowAfterMillis = 30000 }) => {
  return (
    <FadingElementList
      elements={[
        <div key="thinking">
          <i className="fe fe-aperture me-2" style={ICON_STYLE} />
          <span className="">
            {text || (
              <FormattedMessage
                id="app.views.a_i.widgets.a_i_loader.thinking"
                defaultMessage="Thinking..."
              />
            )}
          </span>
        </div>,
        <div key="analyzing">
          <i className="fe fe-box me-2" style={ICON_STYLE} />
          {text || (
            <FormattedMessage
              id="app.views.a_i.widgets.a_i_loader.analyzing"
              defaultMessage="Analyzing..."
            />
          )}
        </div>,
        <div key="ideating">
          <i className="fe fe-cpu me-2" style={ICON_STYLE} />
          {text || (
            <FormattedMessage
              id="app.views.a_i.widgets.a_i_loader.ideating"
              defaultMessage="Ideating..."
            />
          )}
        </div>,
        <div key="generating">
          <i className="fe fe-hard-drive me-2" style={ICON_STYLE} />
          {text || (
            <FormattedMessage
              id="app.views.a_i.widgets.a_i_loader.generating"
              defaultMessage="Generating..."
            />
          )}
        </div>,
      ]}
      footerElementShowAfterMillis={footerElementShowAfterMillis}
      footerElement={
        <div className="pt-2">
          <FormattedMessage
            id="app.views.a_i.widgets.a_i_loader.please_be_patient"
            defaultMessage="Please be patient, this might take up to a minute..."
          />
        </div>
      }
    />
  );
};

export default React.memo(AILoader);
